module.exports = __webpack_public_path__ + "public/img/mini_code.209f0324.jpg";